module.exports = __webpack_public_path__ + "static/media/Morph.c16624ce.jpg";